<script setup lang="ts">
import ChevronRightIcon from "@/core/components/icons/ChevronRightIcon.vue";
import {useRouter} from "vue-router";
import BaseButton from "@/core/components/base/BaseButton.vue";

const router = useRouter();

const props = defineProps<{
    count: number | undefined
    consumerKey?: string
    uniqueConsumers?: boolean
}>();

/**
 * Navigate to index page.
 */
const navigateToPlanIndex = () => {
    router.push({
        name: 'patient-administration.renewal-plans.index',
        ...props.consumerKey ? {
            query: {
                consumer_key: props.consumerKey,
            }
        } : {},
    });
};

</script>

<template>
  <BaseButton
    v-if="count"
    class="text-primary text-xs"
    rounded="lg"
    density="comfortable"
    @click="navigateToPlanIndex"
  >
    <span class="font-semibold pr-1">Voir les plans crées</span>
    <ChevronRightIcon class="inline-block h-4 w-4" />
  </BaseButton>
</template>
